import script from "./TagsIcons.vue?vue&type=script&setup=true&lang=js"
export * from "./TagsIcons.vue?vue&type=script&setup=true&lang=js"

import "./TagsIcons.vue?vue&type=style&index=0&id=858eaeac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-858eaeac"]])

export default __exports__